import { Box, Button, Flex, Image, Spacer } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Icons
import { MdExitToApp } from "react-icons/md";

// Images
import Logo from '../../Assets/Logos/entel-logo.webp';

const AdminNavbar = () => {

    const navigate = useNavigate();

    const infoUser = JSON.parse(localStorage.getItem('infoUser'));

    const exitSession = () => {
        localStorage.removeItem('login');
        navigate('/Login');
    }

    return (
        <Box h="auto" boxShadow="lg">
            <Flex p="3" h="100%">
                <Box w='50px' h='50px'><Image src={Logo} w='100%'/></Box>
                {
                    infoUser.rol === 'Administrador' && 
                    <Button my='auto' ml='5' onClick={() => navigate('/Admin/Dashboard')} className='Subtitle' bg='transparent' border='2px solid #FD3D00' color='#FD3D00' _hover={{bg:'#FD3D00', color:'white'}}>
                        Dashboard
                    </Button>
                }
                {
                    infoUser.rol === 'Disenador' && 
                    <Button my='auto' ml='5' onClick={() => navigate('/Admin/equipos')} className='Subtitle' bg='transparent' border='2px solid #FD3D00' color='#FD3D00' _hover={{bg:'#FD3D00', color:'white'}}>
                        Equipos
                    </Button>
                }

                <Spacer />

                <Button bg="#FD3D00" color='white' className='Subtitle' _hover={{border: '2px solid #FD3D00', color: '#FD3D00', bg: 'white'}} fontWeight="bold" leftIcon={<MdExitToApp size="20px" />} m="auto" onClick={exitSession} mr="5">
                    Cerrar sesión
                </Button>
            </Flex>
        </Box>
    )
}

export default AdminNavbar